// extracted by mini-css-extract-plugin
export default {"logoImg":"logo_logoImg__bbGxl","pop":"logo_pop__XiBTF"};